import { DialogActions, DialogContent } from "@mui/material";
import {
  Button,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import I18n from "i18n-js";
import useUserChangePasswordForm, {
  UseUserChangePasswordFormProps,
} from "./useUserChangePasswordForm";

export interface UserChangePasswordFormProps
  extends UseUserChangePasswordFormProps {
  user: any;
}
export default function UserChangePasswordForm({
  user,
  afterSave,
  onClose,
}: UserChangePasswordFormProps) {
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    requiredFields,
    onChange,
    save,
    saving,
  } = useUserChangePasswordForm({
    id: user?.id,
    afterSave,
  });
  return (
    <>
      <PageHeader
        onClose={onClose}
        title={I18n.t("PasswordChange.title")}
        subtitle={user?.email}
      />
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="PasswordChange.attributes"
          isDirty={getIsDirty}
          requiredFields={requiredFields}
        >
          <FieldsContainer>
            <Field fullWidth>
              <TextField id="password" />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("PasswordChange.change")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
        />
      </DialogActions>
    </>
  );
}
